/* global ga */
import React, { useState, useEffect } from 'react';
import Layout from '../components/Layout';
import Hero from '../sections/Hero';
import Eligibility from '../sections/Eligibility';
import SmartDevices from '../sections/SmartDevices';
import HowItWorks from '../sections/HowItWorks';
import FAQ from '../sections/FAQ';
import ContactUs from '../sections/ContactUs';
import { StaticQuery, graphql } from 'gatsby';
import { trackCustomEvent } from 'gatsby-plugin-google-analytics';

const IndexPage = ({ location }) => (
  <StaticQuery
    query={graphql`
      query LinksQuery {
        allContentfulStudySimpleLink {
          edges {
            node {
              id
              name
              url
            }
          }
        }
      }
    `}
    render={data => {
      const [dynamicLink, setDynamicLink] = useState('');

      useEffect(() => {
        const domain =
          'https://lcresearch.page.link?link=https://lupuscorner.com/sign-up-for-the-oasis-study?';
        let locationParams = location && location.search;
        if (locationParams.charAt(0) === '?') {
          locationParams = locationParams.substring(1);
          locationParams = locationParams.replace(/=/g, '%3D');
          locationParams = locationParams.replace(/&/g, '%26');
        }

        const storeParams =
          '&apn=com.lcresearch.app&isi=1453879235&ibi=com.lcresearch.app';
        const longDynamicLink = `${domain}${locationParams}${storeParams}`;
        console.log(longDynamicLink);

        fetch(
          `https://firebasedynamiclinks.googleapis.com/v1/shortLinks?key=${process.env.FIREBASE_API_KEY}`,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              longDynamicLink
            })
          }
        )
          .then(response => response.json())
          .then(resultData => {
            setDynamicLink(resultData.shortLink);
            //console.log(resultData);
          });
      }, []);

      const { edges } = data.allContentfulStudySimpleLink;

      const grabALink = string => {
        const returnedNode = edges.filter(function(link) {
          return link.node.name.startsWith(string);
        });
        return returnedNode[0].node.url;
      };

      const redirectToStoreByDynamicLink = () => {
        if (dynamicLink) {
          console.log(dynamicLink);
          window.location.replace(dynamicLink);
        }
      };

      const handleJoinClick = () => {
        redirectToStoreByDynamicLink();

        trackCustomEvent({
          category: 'oasis',
          action: 'jointhestudy',
          label: dynamicLink,
          value: 50
        });
      };

      const handleSignUpClick = () => {
        redirectToStoreByDynamicLink();

        trackCustomEvent({
          category: 'oasis',
          action: 'signup',
          label: dynamicLink,
          value: 51
        });
      };

      const handleEnrollNowClick = () => {
        redirectToStoreByDynamicLink();

        trackCustomEvent({
          category: 'oasis',
          action: 'enrollnow',
          label: dynamicLink,
          value: 52
        });
      };

      return (
        <Layout onClick={handleEnrollNowClick}>
          <Hero onClick={handleJoinClick} />
          <Eligibility onClick={handleSignUpClick} />
          <SmartDevices />
          <HowItWorks />
          <FAQ />
          <ContactUs emailUsLink={grabALink('EMAIL US')} />
        </Layout>
      );
    }}
  />
);

export default IndexPage;
